export const LOGO_SRC =
  "https://customer-assets.emergentagent.com/job_boxing-ppv-live/artifacts/0npb8gv8_Adobe%20Express%20-%20file.png";

export default function Logo({ size = 40, withWordmark = true, className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <img
        src={LOGO_SRC}
        alt="Corporate Clash in Macarthur"
        width={size}
        height={size}
        className="rounded-full ring-1 ring-white/15"
        style={{ width: size, height: size, objectFit: "cover" }}
      />
      {withWordmark && (
        <div className="leading-none">
          <div className="font-display text-xl tracking-wider">CORPORATE CLASH</div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-400 mt-1">
            In Macarthur
          </div>
        </div>
      )}
    </div>
  );
}
